import { Box } from '@mui/material'
import PropTypes from 'prop-types'

import { getProductDetails } from '@/common/utils'

const classes = {
    root: {
        height: 128,
        px: 2,
        py: 1,
    },
}

const AppLogo = ({ logoUrl = null, onClick, sx }) => {
    const productDetails = getProductDetails()
    const defaultLogoUrl = `${productDetails.logo}`

    const logoUrlToUse = logoUrl || defaultLogoUrl

    return (
        <Box
            alt="[Logo Image]"
            component="img"
            src={`${logoUrlToUse}`}
            sx={[classes.root, ...(Array.isArray(sx) ? sx : [sx])]}
            onClick={onClick}
        />
    )
}

AppLogo.propTypes = {
    logoUrl: PropTypes.string,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
    onClick: PropTypes.func,
}

export default AppLogo
